import React from 'react'

interface DisplayControlsProps {
	isDisplayWindowOpen: boolean;
	onOpenDisplayWindow: () => void;
	onCloseDisplayWindow: () => void;
	fontSize: number;
	onFontSizeChange: (size: number) => void;
}

export const DisplayControls: React.FC<DisplayControlsProps> = ({
	isDisplayWindowOpen,
	onOpenDisplayWindow,
	onCloseDisplayWindow,
	fontSize,
	onFontSizeChange,
}) => {
	return (
		<div className="display-controls">
			<div className="display-buttons">
				<button
					onClick={onOpenDisplayWindow}
					className="btn btn-secondary"
				>
					{isDisplayWindowOpen ? 'Focus Display Window' : 'Open Display Window'}
				</button>
				<button
					onClick={onCloseDisplayWindow}
					className="btn btn-secondary"
					disabled={!isDisplayWindowOpen}
				>
					Close Display Window
				</button>
			</div>

			{isDisplayWindowOpen && (
				<div className="font-size-control">
					<label htmlFor="font-size-slider">Font Size: {fontSize}px</label>
					<input
						id="font-size-slider"
						type="range"
						min="18"
						max="180"
						value={fontSize}
						onChange={(e) => onFontSizeChange(Number(e.target.value))}
						className="font-size-slider"
					/>
				</div>
			)}
		</div>
	)
}
